<div class="discount" *ngIf="isPromotion">
  {{ "-" + promotionPrice + "%" }}
</div>
